import { clearSearch, search } from "./Search.ts";

export function initChatPanels(): void {
  const chatPanels = document.querySelectorAll(".ui-panel.ui-panel--chats");
  if (!chatPanels) {
    return;
  }
  for (const panel of chatPanels) {
    if (!(panel instanceof HTMLElement)) {
      return;
    }

    const titleBar = panel.querySelector(".ui-panel-titlebar");
    if (!(titleBar instanceof HTMLElement)) {
      continue;
    }

    titleBar.addEventListener("click", () => {
      const contentPanel = panel.querySelector(".ui-panel-content");
      if (contentPanel instanceof HTMLElement) {
        setTimeout(() => {
          scrollPanelContentIntoView(panel);
        }, 600);
      }
    });
  }
}

export function scrollIntoView(chatUuid: string): void {
  const chatPanel = document.querySelector(`.ui-panel[data-chat-uuid='${chatUuid}']`);
  if (chatPanel instanceof HTMLElement) {
    scrollPanelContentIntoView(chatPanel);
  }
}

/**
 * Scrolls the latest currently open chat into view, meaning the latest chat entry of that chat will be scrolled into view.
 */
export function scrollChatIntoView(): void {
  const panels = document.querySelectorAll(".ui-panel.ui-panel--chats");
  for (const panel of panels) {
    if (!(panel instanceof HTMLElement)) {
      continue;
    }
    if (panel.classList.contains("ui-panel-collapsed")) {
      continue;
    }
    const contentPanel = panel.querySelector(".ui-panel-content");
    if (contentPanel instanceof HTMLElement) {
      if (scrollPanelContentIntoView(contentPanel)) {
        return;
      }
    }
  }
}

export function clearTextEditor(): void {
  const textEditor = document.querySelector(".chat-panel__text-editor .ql-editor") as HTMLElement;
  while (textEditor.firstChild) {
    textEditor.removeChild(textEditor.firstChild);
  }
  scrollChatIntoView();
}

export function messageSearch(input: HTMLInputElement, event: KeyboardEvent): boolean {
  if (event.key === "Enter") {
    event.preventDefault();
  }
  const panelWidgets = PrimeFaces.getWidgetsByType(PrimeFaces.widget.Panel);
  if (panelWidgets) {
    for (const panelWidget of panelWidgets) {
      const $panel = panelWidget.jq;
      if ($panel.length !== 1) {
        continue;
      }
      const $panelEl = $panel[0];
      if ($panelEl?.classList.contains("searchable-list-container")) {
        panelWidget.expand();
      }
    }
  }
  search(input);
  return false;
}

export function clearMessageSearch(triggerElement: HTMLElement): void {
  clearSearch(triggerElement);
}

/**
 * Scrolls the panel into view if possible (visible)
 * @param panel to scroll into view
 * @returns true if the panel could be scrolled into view.
 */
function scrollPanelContentIntoView(panel: HTMLElement): boolean {
  const contentPanel = panel.classList.contains("ui-panel-content") ? panel : panel.querySelector(".ui-panel-content");
  if (contentPanel instanceof HTMLElement) {
    const displayStyle = contentPanel.style.display;
    if (displayStyle === "none") {
      return false;
    }
    const lastChatEntry = contentPanel.querySelector(".chat-entry--last");
    if (!lastChatEntry) {
      return false;
    }
    lastChatEntry.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
    return true;
  }
  return false;
}
